import { render, staticRenderFns } from "./InputSignature.vue?vue&type=template&id=0b6635ca"
import script from "./InputSignature.vue?vue&type=script&lang=js"
export * from "./InputSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports